// extracted by mini-css-extract-plugin
export var button = "_9z-4";
export var hasDarkBackground = "_9z-7";
export var hasLightBackground = "_9z-6";
export var iconWrapper = "_9z-0";
export var large = "_9z-2";
export var medium = "_9z-1";
export var small = "_9z-5";
export var xsmall = "_9z-3";